// LUẬT MẬT KHẨU DÙNG CHUNG CHO TOÀN BỘ GIAO DIỆN.
//
// PHẢI KHỚP strongPasswordErr() trong cmd/mdmquery/password.go — cả điều kiện lẫn CÂU
// CHỮ báo lỗi. Lệch câu chữ thì cùng một lỗi người dùng đọc được hai kiểu khác nhau tuỳ
// chỗ FE chặn trước hay backend chặn; lệch điều kiện thì tệ hơn: FE cho qua rồi backend
// từ chối (hoặc ngược lại, FE chặn mật khẩu backend vốn chấp nhận).
//
// "Ký tự đặc biệt" xét theo LOẠI y như bên Go: không phải chữ, không phải số, không phải
// khoảng trắng. Dùng \p{L}/\p{N} (cờ u) chứ KHÔNG dùng [a-zA-Z0-9] — nếu không thì
// "Đường#1" sẽ bị coi là có ký tự đặc biệt ngay ở chữ "ư", lệch hẳn với backend.
//
// Độ dài đếm theo [...v] (rune) chứ không phải v.length (mã UTF-16), để mật khẩu tiếng
// Việt có dấu không bị đếm dôi.
export const MIN_PASSWORD_LEN = 6;

/** Câu gợi ý ngắn để nhét vào placeholder / nhãn ô nhập. */
export const PASSWORD_HINT = `≥${MIN_PASSWORD_LEN} ký tự, có chữ IN HOA và ký tự đặc biệt`;

const isUpper   = (c) => c !== c.toLowerCase() && c === c.toUpperCase();
const isSpecial = (c) => !/[\p{L}\p{N}\s]/u.test(c);

/** Danh sách điều kiện để vẽ checklist tick dần khi người dùng gõ. */
export const PASSWORD_RULES = [
  { key: 'len',     label: `Tối thiểu ${MIN_PASSWORD_LEN} ký tự`,           ok: (v) => [...v].length >= MIN_PASSWORD_LEN },
  { key: 'upper',   label: 'Có ít nhất 1 chữ IN HOA',                       ok: (v) => [...v].some(isUpper) },
  { key: 'special', label: 'Có ít nhất 1 ký tự đặc biệt (@ # ! $ %…)',      ok: (v) => [...v].some(isSpecial) },
];

/** passwordErr: trả '' nếu đạt, ngược lại trả đúng câu backend sẽ trả. */
export function passwordErr(pw) {
  const v = [...String(pw == null ? '' : pw)];
  if (v.length < MIN_PASSWORD_LEN) return `mật khẩu tối thiểu ${MIN_PASSWORD_LEN} ký tự`;
  if (!v.some(isUpper)) return 'mật khẩu phải có ít nhất 1 chữ IN HOA';
  if (!v.some(isSpecial)) return 'mật khẩu phải có ít nhất 1 ký tự đặc biệt (ví dụ @ # ! $ %)';
  return '';
}
